<template>
  <ion-page class="home_page">
    <ion-tabs>
      <ion-router-outlet />
      <ion-tab-bar slot="bottom">
        <ion-tab-button
          v-for="tab in tabs"
          :key="tab.id"
          :tab="tab.tabKey"
          :href="tab.route"
          class="tab-bar-btn w-[150px] relative"
          :style="{
            color: activeTab === tab.route ? '#22BBB3' : '',
          }"
          @click="(e: Event) => handleTabClick(e, tab)"
        >
          <img
            class="w-[48px] h-[48px]"
            :src="activeTab === tab.route ? tab.activeIcon : tab.icon"
            alt=""
          />
          <div class="text-[24px] mt-[4px] van-ellipsis">{{ tab.label }}</div>
          <div
            v-if="tab.id === 4 && showProfileUnreadDot"
            class="absolute top-[4px] right-[36px] w-[16px] h-[16px] rounded-full bg-red-500"
          />
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import {
  IonPage,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonRouterOutlet,
  onIonViewDidEnter,
  onIonViewWillLeave,
} from '@ionic/vue';
import { EUserType, useUserStore } from '@/store';

import { toPage } from '@/utils';
import grassIcon from '@/static/image/tabs/grass.png';
import grassActive from '@/static/image/tabs/grassActive.png';
import promotionIcon from '@/static/image/tabs/promotion.png';
import promotionActive from '@/static/image/tabs/promotionActive.png';
import sellIcon from '@/static/image/tabs/sell.png';
import sellActive from '@/static/image/tabs/sellActive.png';
import announcementIcon from '@/static/image/tabs/announcement.png';
import announcementActive from '@/static/image/tabs/announcementActive.png';
import profileIcon from '@/static/image/tabs/profile.png';
import profileActive from '@/static/image/tabs/profileActive.png';
import { prefetchBannerList } from '@/apis/banner';
import { storage } from '@/plugins/ionic-storage';
import router from '@/router';
import { useChatHistoryStore } from '@/store/chatHistory';

const { t } = useI18n();
defineOptions({
  name: 'TabsLayout',
});

const route = useRoute();
const activeTab = computed(() => route.path);

const userStore = useUserStore();
const chatHistoryStore = useChatHistoryStore();

const showProfileUnreadDot = computed(
  () => userStore.messageCount.total + chatHistoryStore.unReadCount > 0,
);

const tabs = computed(() => [
  {
    id: 0,
    tabKey: 'grass',
    label: t('zc_1'),
    route: '/grass',
    icon: grassIcon,
    activeIcon: grassActive,
  },
  {
    id: 1,
    tabKey: 'promotion',
    label: t('td'),
    route: '/promotion',
    icon: promotionIcon,
    activeIcon: promotionActive,
  },
  {
    id: 2,
    tabKey: 'sell',
    label: t('dh'),
    route: '/sell',
    icon: sellIcon,
    activeIcon: sellActive,
  },
  {
    id: 3,
    tabKey: 'announcement',
    label: t('tg'),
    route: '/announcement',
    icon: announcementIcon,
    activeIcon: announcementActive,
  },
  {
    id: 4,
    tabKey: 'profile',
    label: t('wd'),
    route: '/profile',
    icon: profileIcon,
    activeIcon: profileActive,
  },
]);

const handleTabClick = (e: Event, tab: (typeof tabs.value)[number]) => {
  const logined =
    userStore.user.userId &&
    (userStore.user.type === EUserType.BZ ||
      userStore.user.type === EUserType.TGZ);

  if (tab.id === 3 && !logined) {
    e.preventDefault();
    e.stopImmediatePropagation();
    toPage('/login');
    return;
  }

  if (route.path === tab.route) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
};

onIonViewDidEnter(async () => {
  prefetchBannerList(1);
  const accessToken = await storage.get('accessToken');
  if (accessToken) userStore.getUnreadMsgCount();
});

onIonViewWillLeave(() => {
  userStore.clearMessageTimer();
});
</script>
<style>
.home_page {
  --ion-background-color: transparent;
}

.tab-bar-btn::part(native) {
  flex-direction: column;
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>
